import React from "react";
import "./Logo.css";

export default function Logo() {
  return (
    <div className="site-logo">
      <span className="logo-canopee">ARTIST</span>
      <span className="logo-dot">.</span>
    </div>
  );
}
